import { takeEvery } from 'redux-saga'

import actions from 'actions'
import { gridCancel, gridLoadEventGroup, gridSave } from './grid-sagas'

export function* watchGridLoadEventGroup() {
  yield* takeEvery(actions.GRID_LOAD_EVENT_GROUP, gridLoadEventGroup)
}

export function* watchGridSave() {
  yield* takeEvery(actions.GRID_SAVE, gridSave)
}

export function* watchGridCancel() {
  yield* takeEvery(actions.GRID_CANCEL, gridCancel)
}



/** WEBPACK FOOTER **
 ** ./src/sagas/grid/grid-watchers.js
 **/